import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconType } from '../../interfaces/icon.interface';
@Component({
  selector: 'mg-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class IconComponent implements OnChanges {
  @Input() iconType: IconType = 'material';
  @Input() iconName: string;
  @Input() iconClass: string;
  @Input() isDataLoading: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['isDataLoading']){
      if (changes['isDataLoading']['currentValue']) {
        this.iconClass = this.iconName + ' opacity-40 cursor-not-allowed '
      } else {
        this.iconClass = this.iconName.replaceAll('opacity-40', '');
        this.iconClass = this.iconName.replaceAll('cursor-not-allowed', '');
      }
    }
  }
}